/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Turn_OffInputs */



/**
* | output |
* | --- |
* | "Turn off" |
*
* @param {Notifications_Turn_OffInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_turn_off = /** @type {((inputs?: Notifications_Turn_OffInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Turn_OffInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Désactiver")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desactivar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desativar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Disattiva")
	return /** @type {LocalizedString} */ ("Turn off")
});